import { ChangeDetectionStrategy, Component, effect, input, output, untracked } from '@angular/core';
import { FilterEngineV2Component } from '@iot-platform/iot-platform-ui';
import { FavoriteView, Filter } from '@iot-platform/models/common';
import { SortUtil } from '@iot-platform/iot-platform-utils';
import { isEqual } from 'lodash';

@Component({
  selector: 'iot-platform-ui-favorite-view-filters-form',
  imports: [FilterEngineV2Component],
  templateUrl: './filters-form.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FavoriteViewFiltersFormComponent {
  favoriteView = input<FavoriteView>();
  masterView = input<string>();
  filters = input<Filter[]>();

  formValue = output<Filter[]>();
  formStateChanged = output<boolean>();

  initFiltersEffect = effect(() => {
    const filters = this.filters();
    untracked(() => {
      this.formValue.emit(filters);
      this.emitFormStateChanged(filters);
    });
  });

  onFiltersChange(filters: Filter[]) {
    this.formValue.emit(filters);
    this.emitFormStateChanged(filters);
  }

  private emitFormStateChanged(filters: Filter[] | undefined): void {
    const normalize = (f: Filter[] | undefined) =>
      f?.map(({ criteriaKey, criteriaOperator, value }) => ({ criteriaKey, criteriaOperator, value })).sort(SortUtil.sortByProperty('criteriaKey'));

    this.formStateChanged.emit(!isEqual(normalize(filters), normalize(this.favoriteView()?.filters)));
  }
}
